import type { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';

/** A small grey label with its value underneath: "Created / 23 Jul 2025" */
export function Meta({ label, value, big }: { label: string; value: ReactNode; big?: boolean }) {
  return (
    <Stack>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography component="div" sx={{ fontWeight: big ? 750 : 600, fontSize: big ? 20 : 14 }}>
        {value}
      </Typography>
    </Stack>
  );
}
